export default class BrowserNotificationError extends Error {
    constructor(code, message) {
        super(message);
        this.name = 'BrowserNotificationError'
        this.code = code
    }

    static createNoSupport() {
        return new BrowserNotificationError('browser-no-support', 'Broswer doenst support the Notification API')
    }

    static createPermissionDenied() {
        return new BrowserNotificationError('permission-denied', 'User blocked the permission to the Notification API')
    }
}
